import React, { useState } from "react";
import pluscircle from "../../Assets/plus-circle.png";

interface AccordionItemType {
  index: number;
  question: string;
  answer: string;
  isActive: boolean;
  onClick: (value: number) => void; // Changed to void
}

function AccordionItem({
  index,
  question,
  answer,
  isActive,
  onClick,
}: AccordionItemType) {
  return (
    <div>
      <button
        className="flex justify-between w-full py-4 px-6 text-white bg-gray-700 rounded hover:bg-gray-600 transition duration-200"
        onClick={() => onClick(index)}
        aria-expanded={isActive} // Accessibility feature
      >
        <div className="flex items-center space-x-2">
          <span className="font-bold">
            {index < 9 ? `0${index + 1}` : index + 1}
          </span>
          <h2 className="text-left text-sm md:text-base">{question}</h2>
        </div>
        <span className={`transform ${isActive ? "rotate-180" : ""}`}>
          <img src={pluscircle} alt="Toggle" className="w-6 h-6" />
        </span>
      </button>
      {isActive && (
        <div className="p-6 bg-gray-800 text-gray-400 text-sm md:text-base">
          {answer}
        </div>
      )}
    </div>
  );
}

function Question() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const questions = [
    "Lorem ipsum lorem ipsum Lorem ipsum lorem?",
    "Lorem ipsum lorem ipsum Lorem ipsum lorem?",
    "Lorem ipsum lorem ipsum Lorem ipsum lorem?",
    "Lorem ipsum lorem ipsum Lorem ipsum lorem?",
    "Lorem ipsum lorem ipsum Lorem ipsum lorem?",
  ];

  const answers = [
    "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum.",
    "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum.",
    "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum.",
    "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum.",
    "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum.",
  ];

  return (
    <section className="padding-y bg-gradient-to-r from-gray-800 to-gray-900 text-white mt-10">
      <div className="container mx-auto flex flex-col px-4 md:px-0">
        <div className="w-full h-auto text-center">
          <span className="text-[28px] md:text-[40px] font-extrabold">
            Frequently Asked Questions
          </span>
          <div className="w-full md:w-[75%] lg:w-[60%] h-auto mx-auto mt-4">
            <h4 className="text-sm md:text-base lg:text-lg">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque
              facilis repudiandae quam perferendis tempore nihil, asperiores
              dignissimos autem vitae quisquam voluptatem labore vero provident
              minima ad libero non numquam est.
            </h4>
          </div>
        </div>

        <div className="mt-8 w-full">
          <div className="flex flex-col space-y-4">
            {questions.map((question, index) => (
              <AccordionItem
                key={index}
                index={index}
                question={question}
                answer={answers[index]}
                isActive={activeIndex === index}
                onClick={toggleAccordion} // Simplified
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Question;
